<template> 
    <div style="background:#fff;line-height:30px; padding-top:3px;height:100% "> 
        <div v-if="toolFlag" style="border-bottom:2px solid #389;min-width:1100px; ">
            <span style=" margin-left:10px;font-size:12px;margin-right:10px;">字段查询</span>
            <el-select v-model="selparam"  placeholder="请选择列名" filterable size="small" style="width:150px;margin-left:5px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option v-if="item.thide==='N'" :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam" size="small" style="width:310px;height:30px ">
                <el-select v-model="oper" slot="prepend"  size="small" style="width:100px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
            </el-input>
 
            <el-select v-model="selparam2"  placeholder="请选择列名" filterable size="small" style="width:150px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option v-if="item.thide=='N'" :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam2" size="small" style="width:310px; height:30px;  ">
                <el-select v-model="oper2" slot="prepend" size="small" style="width:100px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
            </el-input>    
        </div>
        <el-table :data="dtlData" 
                border                            
                disabled-hover
                header-cell-class-name="clearPadding"
                :header-cell-style="{ 'color':'#389','text-align':'center'}"
                class="custom-table-border"
                :cell-style="{padding:'2px'}"
                style="overflow:auto;margin-top:3px;"
                v-loading="loading"
                element-loading-background = "rgba(255, 255, 255, .5)"
                element-loading-text = "加载中，请稍后..."
                element-loading-spinner = "el-icon-loading"
                size="small"
                ref="reftab"
                :height="tabHeight" 
                @row-click="rowClick"
                :row-key="getRowKey"
                highlight-current-row>
            <el-table-column label="序号" type="index" width="60" fixed>
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column  v-for="(item ,index) in tabCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"               
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-select v-if="item.key=='MODELNM'" @change="inputQry" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <el-option label="原材料" value="原材料"  ></el-option>
                            <el-option label="产成品" value="产成品"  ></el-option>
                            <el-option label="样板" value="样板"  ></el-option>
                            <el-option label="SKU组合" value="SKU组合"  ></el-option>   
                        </el-select>
                        <el-date-picker v-else-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-input type="number" placeholder="数字框"  @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">正常</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='N'" size="mini" type="info" effect="dark">作废</el-tag>                         
                        <el-link v-else-if="item.key=='imgpath' " :underline="false" > 
                            <el-image fit="scale-down"  style="width:80px;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </el-link>
                        <el-tag  v-else-if="item.key=='GPNM' " size="mini" type="info" effect="dark">{{scope.row[item.key]}}</el-tag>  
                        <span v-else v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column>
            </el-table-column> 
 
        </el-table>
        <div style=" overflow: hidden;display:flex;width:100%;margin-top:3px;align-items:center;font-size:12px;line-height:30px;height:33px">
            <div style="float: left;padding-left:4px;font-size:12px">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
 
        </div> 
        <!-- 提示 -->
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!--  物料日志明细 -->
        <div class="one-toolbar"  >
            <span class="spanRow">物料日志明细</span>
        </div>                 
        <el-table :data="logData" 
                border                            
                disabled-hover
                class="custom-table-border"
                style="overflow:auto;margin-top:-5px;"
                :header-cell-style="headStyle"
                size="small"
                height="180px" 
                highlight-current-row>
                <el-table-column  v-for="(item ,index) in logCol.filter(item=>item.fhide=='N')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"  
                    :min-width="item.width">
                </el-table-column>         
        </el-table>
    </div>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
import {getDate} from '../../api/Select' 
export default {
    name: 'sample_stklog',
    props: {
        toolFlag:{
            type:Boolean,
            default:true
        },
        v_cond:{
            type:String,
        }
    },
    data () {
        return {
            v_row:{},
            selparam2:'MATNO',// select 绑定值
            oper2:'like',
            txtparam2:'', // input 绑定值
            rowIdseq:'', // 
            prompt:'', // 
            promptWin:false,
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'STKNM',// select 绑定值
            oper:'like',
            txtparam:'', // input 绑定值
            tabCol:[] ,//表列集合
            logCol:[],
            logData:[] ,// 
            dtlData:[],
            dataCount:0,
            rowSize:50,
            goPage:'',
            current:1,
            baseData:[] ,//表数据
            operArr:[],
            orgData:[] ,//组织部门
            editrmk:'',//  
            rowLstseq:'' ,//
            disabled:false,
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'',
                label: 'label'
            },
            v_url:'xuper_auth/getTableRecMany', //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            type:'create',
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
                } ],
            stfgBool:true,
            formCol:{}, //表格单行记录 model
            allData:[],
            notNull:[],
            treeid:'0',
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止 
            v_admin:this.$cookies.get('v_admin') ,//  
        }
    },
    created () {
        this.getTabCol() //得到 表列数组 
        if (this.toolFlag){
            this.getFormData('') //初始查询表数据   
        }else{
          this.getFormData(this.v_cond)  
        }
    },
    components: {
 
    },
    watch: {
        v_cond:function(){ //侦测变量值改变时 执行此方法
            this.getFormData(this.v_cond)  
        }   
    },
    mounted () {   
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
    } ,
    computed: {
        tabHeight() {
          return  (window.innerHeight -380)+'px'
        },
        logHeight() {
          return  window.innerHeight -160
        },
        tabWidth() {
          return  (window.innerWidth -140)+'px'
        },
    },
    methods: { 
        headStyle({column,columnIndex}){
             if (column['property']=='BALQTY'){
                return 'color:red'
             }
        },
        rowClick(row){
 
            this.getLogData(row['STKNO'],row['MATNO'] ) 
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promtWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.dtlData = this.allData          
            }else{
               
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.dtlData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.dtlData = this.allData.slice(_start,_end);
        }, 
        getRowKey(row){
            return row.PKSEQ
        },
        //字段查询
        inputQry(){
            this.qryTabData('')
        },
 
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryTabData('')
        } ,
        //查询表格数据
        qryTabData(){
            let cond_='' ,v_edcss='' ,v_cond =''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                }
            }
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                        }
                    }
                }
            })
            this.getFormData(cond_ +v_cond)
        },
 
        //获取表单数据
        getFormData(cond){
            var vm=this
            this.loading =true
            getTabColOrData(this.v_formurl,'v_SMP_STKLOG','corpid',this.v_corpid,'','','','',cond+' order by '+this.selparam+' desc').then((res) => {              
                if (res.code==='200'){
                    this.allData=res.result   
                    this.initPage() 
                    this.logData=[]
                    if (this.allData.length>0){
                        this.$refs['reftab'].setCurrentRow(this.allData[0])
                        this.getLogData(this.allData[0]['STKNO'],this.allData[0]['MATNO'] ) 
                    }
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                vm.loading =false         
            })       
        },
        //日志记录
        getLogData(stkno,matno){
            this.logData=[]
            let v_cond =' and stkno=\''+stkno+'\' and stfg=\'Y\' order by CHKdttm'
            getTabColOrData(this.v_formurl,'v_SMP_STKLOG_DTL','corpid',this.v_corpid,'','','matno',matno ,v_cond).then((res) => {                          
                if (res.code==='200'){
                    this.logData=res.result  
                    // res.result.forEach(item=>{
                    //     if (item['TOSTKNO']==stkno){
                    //         this.logData.push(Object.assign(item,{BALQTY:item['BALQTY2']}))
                    //     }else{
                    //         this.logData.push(item)
                    //     }
                    // }) 
                }
            })           
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','430446','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        sortable: res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','430446','LSTSEQ','2' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.logCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        sortable: res.result[k].SORTABLE,
                    })
                }
            })
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .el-table__body tr.current-row > td {
        background-color: #F1e1ff !important;
    } 
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
